export default __webpack_public_path__ + "static/media/image1.39d283fe.png";